export const testAttributes = {
    AUTHOR_BIO_CONTAINER: 'author_bio_container',
    AUTHOR_BIO_AVATAR: 'author_bio_avatar',
    AUTHOR_BIO_AVATAR_IMAGE: 'author_bio_avatar_image',
    AUTHOR_BIO_NAME: 'author_bio_name',
    AUTHOR_BIO_EXPERTISE: 'author_bio_expertise',
    AUTHOR_BIO_EDUCATION: 'author_bio_education',
    AUTHOR_BIO_SOCIAL: 'author_bio_social',
};

export const socialId = {
    fb: 'fbsb',
    tw: 'twsb',
    ig: 'igsb',
    em: 'emsb',
    li: 'lisb',
    yt: 'ytsb',
    pi: 'pisb',
};
